
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getApprovalstatus} from 'sr/utils/api/masterData/approvalstatus/getApprovalstatus'
export const fetchapprovalstatus = createAsyncThunk(
  'getApprovalstatus',
  async () => {
    const response = await getApprovalstatus()
    return response?.data
  }
)


